/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams,
  GetApiV1IndividualpaymentParcelsParcelidSerials401,
  GetApiV1IndividualpaymentParcelsParcelidSerials500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelidSerials.ts";

function getGetApiV1IndividualpaymentParcelsParcelidSerialsUrl(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams["parcelId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/parcels/${parcelId}/serials` as const,
  };
  return res;
}

/**
 * @description Retorna os seriais registrados da parcela com situação, estação, ticket, linha digitável e cancelamento. Migrado do legado IndividualPayment/LoadGridDataAsyncPaymentSerial. **(Requer Authorization para autenticação)**
 * @summary Retorna os seriais de pagamento (boletos) de uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/serials}
 */
export async function getApiV1IndividualpaymentParcelsParcelidSerials(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams["parcelId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidSerials401
      | GetApiV1IndividualpaymentParcelsParcelidSerials500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentParcelsParcelidSerialsUrl(
      parcelId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
